<script>
	import { onMount } from 'svelte';
	import { authState, isAuthenticated, initAuth } from './lib/auth.js';
	import Login from './routes/Login.svelte';
	import EmailActionsGuide from './routes/EmailActionsGuide.svelte';
	import Briefing from './routes/Briefing.svelte';
	import ExplorerTree from './routes/ExplorerTree.svelte';
	import Query from './routes/Query.svelte';
	import Source from './routes/Source.svelte';
	import ConceptFull from './routes/ConceptFull.svelte';
	import ConnectV2 from './routes/ConnectV2.svelte';
	import Ops from './routes/Ops.svelte';
	import Admin from './routes/Admin.svelte';
	import Gardener from './routes/Gardener.svelte';
	import ZenReader from './routes/ZenReader.svelte';

	let path = window.location.pathname;

	// Listen for popstate (back/forward)
	function handlePopState() {
		path = window.location.pathname;
	}

	// Navigation helper - used by child components
	function navigate(newPath) {
		window.history.pushState({}, '', newPath);
		path = newPath;
	}

	// Route matching
	// /explorer is the canonical concept-tree route. /tree and /v4 remain as
	// silent aliases so old bookmarks and in-flight links don't 404.
	$: route = path === '/zen' ? 'zen'
		: path === '/source' ? 'source'
		: (path === '/explorer' || path === '/tree' || path === '/v4') ? 'explorer'
		: path === '/query' ? 'query'
		: path.startsWith('/concept/') ? 'concept'
		: (path === '/discover' || path === '/briefing') ? 'discover'
		: path === '/connect' ? 'connectv2'
		: path === '/ops' ? 'ops'
		: path === '/admin' ? 'admin'
		: path === '/gardener' ? 'gardener'
		: path.startsWith('/guide/') ? 'guide'
		: 'home';

	$: conceptId = path.startsWith('/concept/')
		? decodeURIComponent(path.slice(9))
		: null;

	// Redirect to login/splash if not authenticated and trying to access protected routes
	$: if (!$authState.loading && !$isAuthenticated && (route === 'source' || route === 'explorer' || route === 'query' || route === 'concept' || route === 'discover' || route === 'connectv2' || route === 'ops' || route === 'admin' || route === 'gardener')) {
		navigate('/');
	}

	onMount(() => {
		initAuth();
		window.addEventListener('popstate', handlePopState);
		return () => window.removeEventListener('popstate', handlePopState);
	});
</script>

{#if route === 'zen'}
	<ZenReader />
{:else if $authState.loading && route !== 'guide'}
	<div class="loading-page">
		<span class="loading-brand">ADRASI</span>
	</div>
{:else if route === 'guide'}
	<EmailActionsGuide {navigate} />
{:else if route === 'discover' && $isAuthenticated}
	<Briefing {navigate} />
{:else if route === 'source' && $isAuthenticated}
	<Source {navigate} />
{:else if route === 'explorer' && $isAuthenticated}
	<ExplorerTree {navigate} />
{:else if route === 'query' && $isAuthenticated}
	<Query {navigate} />
{:else if route === 'concept' && $isAuthenticated}
	<ConceptFull nodeId={conceptId} {navigate} />
{:else if route === 'connectv2' && $isAuthenticated}
	<ConnectV2 {navigate} />
{:else if route === 'ops' && $isAuthenticated}
	<Ops {navigate} />
{:else if route === 'admin' && $isAuthenticated}
	<Admin {navigate} />
{:else if route === 'gardener' && $isAuthenticated}
	<Gardener {navigate} />
{:else}
	<Login {navigate} />
{/if}

<style>
	.loading-page {
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 100vh;
	}

	.loading-brand {
		font-size: 32px;
		font-weight: 800;
		color: #D1D5DB;
		letter-spacing: -0.5px;
		animation: pulse 1.5s ease-in-out infinite;
	}

	@keyframes pulse {
		0%, 100% { opacity: 0.4; }
		50% { opacity: 1; }
	}
</style>
